import Request from './request';

export const apiGetTrucks = async (id, filters = {}) => {
  return Request.call({
    url: `/company/${id}/trucks/list`,
    method: 'GET',
    params: filters,
  });
};

export const apiCreateUpdateTruck = async (id, data) => {
  return Request.call({
    url: `/company/${id}/trucks`,
    method: 'POST',
    data,
  });
};
export const apiUpdateTruckStatus = async (companyId, truckId, data) => {
  return Request.call({
    url: `/company/${companyId}/trucks/${truckId}/status`,
    method: 'POST',
    data,
  });
};
